module.exports = __webpack_public_path__ + "img/banner02.b571a50c.jpg";